<template>
  <div class="crud_form_wrapper app_settings_class">
    <div class="table_title_wrapper">
      <div class="title_text_wrapper">
        <h5 style="color: #e1423d" class="font-weight-bold">
          {{ $t("SIDENAV.settings.general") }}
        </h5>
      </div>
      <div class="col-12 text-end">
        <v-btn @click="$router.go(-1)" style="color: #e1423d">
          <i class="fas fa-backward"></i>
        </v-btn>
      </div>
    </div>
    <div class="single_step_form_content_wrapper">
      <form @submit.prevent="validateFormInputs">
        <div class="row">
          <base-input
            type="number"
            col="6"
            :placeholder="$t('PLACEHOLDERS.VAT_percentage')"
            v-model.trim="data.VAT_percentage"
            required
          />

          <base-input
            type="number"
            col="6"
            :placeholder="$t('PLACEHOLDERS.return_window_hours')"
            v-model.trim="data.return_window_hours"
            required
          />

          <div class="input_wrapper switch_wrapper my-5">
            <v-switch
              color="green"
              :label="$t('PLACEHOLDERS.cashPayment')"
              v-model="data.cashPayment"
              hide-details
            ></v-switch>
          </div>

          <div class="btn_wrapper">
            <base-button
              class="mt-2"
              styleType="primary_btn"
              :btnText="$t('BUTTONS.save')"
              :isLoading="isWaitingRequest"
              :disabled="isWaitingRequest"
            />
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  name: "AppSetting",
  data() {
    return {
      isWaitingRequest: false,
      data: {
        cashPayment: false,
        VAT_percentage: null,
        return_window_hours: null,
      },
    };
  },
  methods: {
    async getDataToEdit() {
      try {
        let res = await this.$axios.get("settings");
        const settingsArray = res.data.data;

        // Find cash_payment_enabled setting
        const deliveryFeeSetting = settingsArray.find(
          (setting) => setting.key === "cash_payment_enabled"
        );
        if (deliveryFeeSetting) {
          // Convert "1" or "0" to boolean
          this.data.cashPayment = deliveryFeeSetting.value;
        }

        // Find tax_percentage setting
        const taxPercentageSetting = settingsArray.find(
          (setting) => setting.key === "tax_percentage"
        );
        if (taxPercentageSetting) {
          this.data.VAT_percentage = taxPercentageSetting.value;
        }

        const returnWindowHoursSetting = settingsArray.find(
          (setting) => setting.key === "return_window_hours"
        );
        if (returnWindowHoursSetting) {
          this.data.return_window_hours = returnWindowHoursSetting.value;
        }
      } catch (error) {
        console.error(error.response?.data?.message || error.message);
      }
    },
    async submitForm() {
      this.isWaitingRequest = true;
      const REQUEST_DATA = new FormData();
      // Convert boolean to 1 or 0
      REQUEST_DATA.append("cash_payment_enabled", this.data.cashPayment);
      REQUEST_DATA.append("tax_percentage", this.data.VAT_percentage);
      REQUEST_DATA.append("return_window_hours", this.data.return_window_hours);
      try {
        await this.$axios.patch("settings", REQUEST_DATA);
        this.isWaitingRequest = false;
        this.$message.success(this.$t("MESSAGES.savedSuccessfully"));
        this.getDataToEdit();
      } catch (error) {
        this.isWaitingRequest = false;
        this.$message.error(error.response?.data?.message || error.message);
      }
    },
    validateFormInputs() {
      // Validate VAT percentage range
      const vatPercentage = parseFloat(this.data.VAT_percentage);
      if (isNaN(vatPercentage) || vatPercentage < 0 || vatPercentage > 100) {
        this.$message.error(this.$t("VALIDATION.vatPercentageRange"));
        return;
      }

      const returnWindowHours = parseInt(this.data.return_window_hours, 10);
      if (isNaN(returnWindowHours) || returnWindowHours <= 0) {
        this.$message.error(this.$t("VALIDATION.return_window_hours"));
        return;
      }

      this.submitForm();
    },
  },
  created() {
    this.getDataToEdit();
  },
};
</script>
